import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Platformuna() {
  return (
    <section className="platform_una p-100 text_una">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              <strong>The Platform's Starred Highlighted Features</strong>
              <br /> Tackling With Features And Complexities
            </h2>
            <p>
              UNA Job Portal was designed with one goal in mind – to facilitate
              fresh graduates in finding a suitable job. The job industry faces
              ups and downs every day, and students needed a platform to start
              their careers. The platform was designed to attract hiring
              professionals who were looking to employ fresh graduates. The
              platform is a safe space for students where they can connect with
              prestigious companies via job ads. Students can search for
              entry-level jobs, and employers can connect with potential
              candidates to fill vacancies.
            </p>
            <ul>
              <li>
                An easy sign-up page where students can use their university
                email addresses to register within seconds.
              </li>
              <li>
                An interface where candidates can upload their detailed profiles
                and their pictures.
              </li>
              <li>
                A portal for employers to create company profiles and place job
                ads to attract candidates.
              </li>
              <li>
                A search feature for employers and candidates which they can use
                to browse by field, salary packages, benefits, preferred shifts,
                and experience.
              </li>
            </ul>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 offset-md-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/una/platform_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={800}
                height={625}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Platformuna;
